export default "__VITE_ASSET__fc19ba6b__"